import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDetailsFormLoaderData } from '../loaders/StudentWarningsSummaryDetailsFormLoader';
import {
  StudentWarningsRiskLevel,
  StudentWarningsSummaryDetailsWarning,
} from '../types';

type StudentWarningsSummaryDetailsBlockProps = {
  item: StudentWarningsSummaryDetailsWarning;
};

const BG_COLORS: Record<StudentWarningsRiskLevel, string> = {
  [StudentWarningsRiskLevel.Low]: '#CEF0DA',
  [StudentWarningsRiskLevel.Medium]: '#FFEFC6',
  [StudentWarningsRiskLevel.High]: '#FCEEED',
};

const StudentWarningsSummaryDetailsBlock = ({
  item,
}: StudentWarningsSummaryDetailsBlockProps) => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_DETAILS);
  const data = useWarningsSummaryDetailsFormLoaderData();

  const label = useMemo(() => {
    if (item.type === 'totalRisk') {
      return t('totalRisk');
    }
    return data?.warningGroups.find((group) => group.value === item.type)
      ?.label;
  }, [data?.warningGroups, item.type, t]);

  return (
    <Card
      className="border border-primary"
      style={{
        backgroundColor: item.riskLevel ? BG_COLORS[item.riskLevel] : 'white',
      }}
    >
      <Container fluid>
        <Row className="pb-4 gutters-filters py-4">
          <Col className="mb-3" xs={12}>
            <span className="fs-20 text-uppercase text-primary mb-0 fw-700">
              {label}
            </span>
          </Col>
          <Col xs={6}>
            <div className="w-100 d-block">
              <span className="w-100 d-block fs-12 text-uppercase mb-0">
                {t('detailBlock.riskLevel')}
              </span>
              <span className="w-100 d-block fs-12 text-uppercase text-primary mb-0 fw-700">
                {t(`riskLevels.${item.riskLevel ?? 'NULL'}`)}
              </span>
            </div>
          </Col>
          <Col xs={6}>
            <div>
              <span className="w-100 d-block fs-12 text-uppercase mb-0">
                {t('detailBlock.warnings')}
              </span>
              <span className="w-100 d-block fs-12 text-uppercase text-primary mb-0 fw-700">
                {t('detailBlock.warningsCount', { count: item.warnings })}
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default StudentWarningsSummaryDetailsBlock;
